import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addColumn, fileUploadRequest, removeColumn, updateColumn } from 'src/containers/data-center-container/Data-center/actions/DataCenterActions';

const SheetUploadModal = ({ closeModal, sheetUrl, dataCenterId }) => {
    const dispatch = useDispatch();
    const { data: columns, loading } = useSelector(state => state.dataCenter?.fileHeaders);
    const setColumns = () => { }
    const [uniqueId, setUniqueId] = useState('');
    const [addNewCols, setAddNewCols] = useState(false);
    const [updateCols, setUpdateCols] = useState(false);
    const [draggingIndex, setDraggingIndex] = useState(null);

    const handleAddColumn = () => {
        dispatch(addColumn());
    };

    const handleRemoveColumn = (id) => {
        dispatch(removeColumn(id));
    };

    const handleSave = () => {
        if (!uniqueId || uniqueId === '') {
            return toast.error('Please select unique id')
        }
        dispatch(fileUploadRequest({ sheetUrl, uidHeaderName: uniqueId, dataCenterId, headersData: columns }))
        closeModal()
    }

    const handleUidChange = (e) => {
        setUniqueId(e.target.value)
    };
    const handleAddNewColsToggle = () => setAddNewCols(!addNewCols);
    const handleUpdateColsToggle = () => setUpdateCols(!updateCols);

    const handleDragStart = (index) => {
        setDraggingIndex(index);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, targetIndex) => {
        e.preventDefault();
        if (draggingIndex === targetIndex) return;

        const updatedColumns = [...columns];
        const draggedColumn = updatedColumns.splice(draggingIndex, 1)[0];
        updatedColumns.splice(targetIndex, 0, draggedColumn);

        setColumns(updatedColumns);
        setDraggingIndex(null);
    };

    const handleColumnChange = (fieldName, newValue) => {
        dispatch(updateColumn(fieldName, newValue));
    };

    return (
        <>
            <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Sheet Upload</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            {loading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="column-container">

                                        {columns.map((column, index) => (
                                            <div
                                                key={index}
                                                className="draggable"
                                                draggable="true"
                                                onDragStart={() => handleDragStart(index)}
                                                onDragOver={handleDragOver}
                                                onDrop={(e) => handleDrop(e, index)}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '10px',
                                                    border: '1px solid #ddd',
                                                    margin: '5px 0',
                                                    backgroundColor: '#ffffff',
                                                    cursor: 'move',
                                                    border: 'none',
                                                }}
                                            >
                                                <span className="handle" style={{ marginRight: '10px' }}>
                                                    ⋮⋮
                                                </span>
                                                <div style={{ flex: 1 }}>
                                                    <label className="form-label">column {column.order}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={column.headerValue}
                                                        disabled={!updateCols}
                                                        onChange={(e) => handleColumnChange(column.fieldName, e.target.value)}
                                                    />
                                                </div>
                                                <button
                                                    className="delete"
                                                    onClick={() => handleRemoveColumn(index)}
                                                    style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                                                >
                                                    <svg
                                                        width={16}
                                                        height={19}
                                                        viewBox="0 0 16 19"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M2.64119 5.52612C2.39242 5.52612 2.15491 5.62989 1.98587 5.81242C1.81684 5.99495 1.7316 6.23972 1.75068 6.48778L2.45352 15.6248C2.5967 17.4861 4.14878 18.9233 6.01559 18.9233H9.98456C11.8514 18.9233 13.4034 17.4861 13.5466 15.6248L14.2495 6.48778C14.2685 6.23972 14.1833 5.99495 14.0143 5.81242C13.8453 5.62989 13.6077 5.52612 13.359 5.52612H2.64119Z"
                                                            fill="#94A3B8"
                                                        />
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M14.2522 1.95353C14.7455 1.95353 15.1453 2.35341 15.1453 2.84668C15.1453 3.33995 14.7455 3.73983 14.2522 3.73983H1.74813C1.25486 3.73983 0.85498 3.33995 0.85498 2.84668C0.85498 2.35341 1.25486 1.95353 1.74813 1.95353L6.07524 1.95352C6.42117 1.95352 6.74431 1.78062 6.93616 1.49276C7.4423 0.733529 8.55802 0.733538 9.06417 1.49276C9.25602 1.78062 9.57916 1.95352 9.92507 1.95352L14.2522 1.95353Z"
                                                            fill="#94A3B8"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        ))}
                                    </div>

                                    {addNewCols && (
                                        <button className="btn btn-outline-primary" onClick={handleAddColumn}>
                                            Add Column
                                        </button>)}

                                    <div className="uniqIdSelect">
                                        <div className="selectSec filterStyleSec">
                                            <label>Unique Identifier (UID)</label>
                                            <select className="searchOption" onChange={handleUidChange} value={uniqueId}>
                                                <option value="">Select Unique Identifier Column</option>
                                                {columns.map((column) => (
                                                    <option key={column.order} value={column.fieldName}>
                                                        {column.headerValue}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="contentAddColsSec">
                                        <label className="toggleText">Add New Columns</label>
                                        <label className="switchSmall m5">
                                            <input
                                                type="checkbox"
                                                checked={addNewCols}
                                                onChange={handleAddNewColsToggle}
                                            />
                                            <small />
                                        </label>
                                    </div>

                                    <div className="contentAddColsSec">
                                        <label className="toggleText">Update Existing Columns</label>
                                        <label className="switchSmall m5">
                                            <input
                                                type="checkbox"
                                                checked={updateCols}
                                                onChange={handleUpdateColsToggle}
                                            />
                                            <small />
                                        </label>
                                    </div>

                                    <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                </>)}
                        </div>

                    </div>
                </div>
            </div>

            {/* Modal Backdrop with Darker Overlay */}
            <div
                className="modal-backdrop fade show"
                style={{
                    zIndex: 1040,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Adjust opacity here to make it darker
                }}
            ></div>
        </>
    );
};

export default SheetUploadModal;
